/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colorMap } from "../../orders/utils/getOrderStatus";
import { Quote, QuoteStatus, QuoteStatusType } from "../storage/types";

export const mapQuoteStatus = (status: QuoteStatusType) => {
  switch (status) {
    case QuoteStatus.Offered:
      return {
        display: "Ready to accept",
        color: colorMap["orange"],
      };
    case QuoteStatus.Ordered:
      return {
        display: "Order Placed",
        color: colorMap["green"],
      };
    case QuoteStatus.Requested:
      return {
        display: "Requested",
        color: colorMap["green"],
      };
    case QuoteStatus.Cancelled:
      return {
        display: "Cancelled",
        color: colorMap["grey"],
      };
    case QuoteStatus.Rejected:
      return {
        display: "Declined",
        color: colorMap["grey"],
      };
    case QuoteStatus.Expired:
      return {
        display: "Expired",
        color: colorMap["grey"],
      };
    case QuoteStatus.Created:
      return {
        display: "Created",
        color: colorMap["grey"],
      };
  }
};

export const showQuoteAsTwoColumnLayout = (quote: Quote): boolean => {
  return [QuoteStatus.Offered, QuoteStatus.Requested].includes(quote.status);
};

export const isQuoteStatusRequested = (quote: Quote) => {
  return quote.status === QuoteStatus.Requested;
};
